import { render } from "./newClients.vue?vue&type=template&id=b6d565a6&scoped=true"
import script from "./newClients.vue?vue&type=script&lang=js"
export * from "./newClients.vue?vue&type=script&lang=js"

import "./newClients.vue?vue&type=style&index=0&id=b6d565a6&scoped=true&lang=css"

import exportComponent from "/var/www/html/heritage/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6d565a6"]])

export default __exports__